var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71,
    height: 89,
    viewBox: "0 0 71 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2221",
    "data-name": "Rectangle 2221",
    width: 71,
    height: 89,
    transform: "translate(0 0)",
    fill: "#d9000d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10512",
    "data-name": "Group 10512",
    transform: "translate(0.869 0.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10356",
    "data-name": "Group 10356",
    transform: "translate(-0.869 -0.187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27732",
    "data-name": "Path 27732",
    d: "M21.831,34.93H26.2a4.366,4.366,0,1,0,0-8.732H21.831a4.366,4.366,0,0,0,0,8.732m0,8.732a4.366,4.366,0,1,0,0,8.732h26.2a4.366,4.366,0,1,0,0-8.732ZM69.86,30.29a4.938,4.938,0,0,0-.274-1.159v-.408a3.879,3.879,0,0,0-.821-1.205l-26.2-26.2A3.968,3.968,0,0,0,41.345.477a1.1,1.1,0,0,0-.39,0A4.12,4.12,0,0,0,39.523,0H13.1A13.1,13.1,0,0,0,0,13.1V74.226a13.1,13.1,0,0,0,13.1,13.1H56.761a13.1,13.1,0,0,0,13.1-13.1V30.29M43.662,14.9l11.3,11.3H48.029a4.368,4.368,0,0,1-4.366-4.366ZM61.127,74.226a4.368,4.368,0,0,1-4.366,4.366H13.1a4.368,4.368,0,0,1-4.366-4.366V13.1A4.368,4.368,0,0,1,13.1,8.732H34.93v13.1a13.1,13.1,0,0,0,13.1,13.1h13.1Zm-13.1-13.1h-26.2a4.366,4.366,0,1,0,0,8.732h26.2a4.366,4.366,0,1,0,0-8.732",
    transform: "translate(1.05 0.564)",
    fill: "#d9000d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearedIcon);
export default __webpack_public_path__ + "static/media/cleared_icon.1e390561f209c624133e518f09045539.svg";
export { ForwardRef as ReactComponent };